import { useQuery } from '@tanstack/react-query';
import { getInvoicesCountDraft } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoicesCountDraft() {
    const { data: invoicesCount = 0, isLoading } = useQuery({
        queryKey: ['invoices', 'count', 'draft'],
        queryFn: getInvoicesCountDraft,
        onError: (error) => trackError(error),
    });

    return {
        invoicesCount,
        isLoading,
    };
}
